const ActivePodcastEpisode = (episodeIndex = {}, action) =>{
    switch (action.type) {
        case 'ACTIVEPODCASTITEM':
            return action.payload;        
        default:
            return episodeIndex;
    }
}

export default ActivePodcastEpisode;